import React from 'react';
import ItemMenu from '@catalogo/ui-americanas-desktop-item-menu';
import styled from 'styled-components';

const Categories = ({ categories: sections, dispatchMetrics }) => (
  <Menu>
    <Container>
      {sections.map(section => (
        <ItemMenu key={section.id} item={section} nivel={0} dispatchMetrics={dispatchMetrics} />
      ))}
    </Container>
  </Menu>
);

export default Categories;

const Menu = styled.div`
  height: 100%;
  padding: 16px 0;
  max-width: 740px;
  margin: 0;
`;

const Container = styled.div`
  column-count: 3;
  column-fill: auto;
  min-width: 500px;
  height: 100%;
`;
